<template>
  <div class="d-flex justify-content-between align-items-center">
    <ul class="post__meta d-flex list-unstyled">
      <li v-text="createdAt"></li>
      <li v-text="readTime"></li>
    </ul>
    <post-widgets :post="post" />
  </div>
</template>

<script>
import PostWidgets from './PostWidgets'

export default {
    name: "PostMeta",
    props: {
        post:{ required: true, type: Object }
    },
    components: { PostWidgets },
    computed:{
        readTime(){
            let { read_time } = this.post
            return `На чтение ${read_time} мин.`
        },
        createdAt(){
            let { created_at } = this.post
            return (created_at.split('T')[0]).split('-').reverse().join('.')
        }
    },

};
</script>
